import { render, staticRenderFns } from "./smallpackage_list.vue?vue&type=template&id=6eede383&"
import script from "./smallpackage_list.vue?vue&type=script&lang=js&"
export * from "./smallpackage_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports